import React, { useState, useEffect, useRef } from "react";
import { ReactSVG } from "react-svg";
import { render } from "react-dom";

import Image from "next/image";
import Link from "next/link";

import AppLogo from "../../../public/assets/img/app-logo.png";
import AboutUs from "../../../public/assets/img/about-us.png";
import C2A from "../../../public/assets/img/how-can-we-help.png";
import Search from "../../../public/assets/img/SVGSearch.svg";
import FBicon from "../../../public/assets/img/facebook.png";
import IGicon from "../../../public/assets/img/instagram.png";
import Twittericon from "../../../public/assets/img/twitter.png";
import QuoteIcon from "../../../public/assets/img/icons/quote-icon-1.svg";

import About1 from "../../../public/assets/img/PMHA-Facade-Orig-1.jpeg";
import Img1 from "../../../public/assets/img/img-1.jpg";
import Img2 from "../../../public/assets/img/img-2.jpg";
import Img3 from "../../../public/assets/img/img-3.jpg";

import HeaderNav from "../../includes/HeaderNav";
import Footer from "../../includes/Footer";
import BookingSec from "./BookingCTA";
import Stats from "./Stats";

const About = () => {
  return (
    <>
      {/* MAIN NAV */}
      <HeaderNav />

      <section id="about-header" className="lg:mt-52 mt-40">
        <div className="max-w-screen-2xl mx-auto sm:px-10 px-8">
          <div className="grid">
            <h1 className="text-blue md:text-4xl text-3xl font-semibold text-center leading-snug mb-10">
              Philippine Mental Health Association, Inc.
            </h1>
            <div className="text-center max-w-4xl mx-auto">
              <Image src={About1} alt="" className="rounded-xl" />
            </div>
          </div>
          <div className="grid mt-16">
            <div className="max-w-5xl mx-auto text-center mb-10">
              <p className="text-justify sm:text-lg text-base">
                Founded on January 15, 1950, the Philippine Mental Health
                Association, Inc. (PMHA) is a private, non-stock, non-profit
                organization that provides premier Mental Health Services
                through Education, Advocacy, Intervention and Research.
              </p>
            </div>
            <div className="max-w-5xl mx-auto text-center">
              <h2 className="sm:text-4xl text-3xl font-semibold border-b border-b-gray-300 pb-5 mb-3">
                Why We Exist
              </h2>
              <p className="text-justify sm:text-lg text-base pt-4 pb-5">
                PMHA has been at the forefront of mental health advocacy for{" "}
                <strong>
                  {new Date().getFullYear() -
                    new Date("January 15, 1950").getFullYear()}{" "}
                  years now
                </strong>
                , reaching out and changing millions of lives by raising
                individual productivity, fostering resiliency and equipping them
                with overall mental wellness.
              </p>
              <p className="text-justify sm:text-lg text-base">
                We have over 300,000 stakeholders, 2,000 members, 8 chapters and
                1 satellite in different key cities, 14 M viewers and listeners
                through multimedia platforms and 150 socially conscious
                volunteers for their own communities. PMHA continues to evolve
                by formulating new quality programs to respond to the changing
                times.
              </p>
            </div>
          </div>

          <div className="lg:flex block items-stretch mt-16">
            <div className="bg-sky-100 lg:w-1/3 w:auto flex-1 sm:p-10 p-8 my-5 lg:mx-5 mx-0 rounded-3xl">
              <h3 className="sm:text-2xl text-xl">Our Vision</h3>
              <p className="text-justify sm:text-lg text-base pt-0">
                The Filipino people with the highest level of mental health.
              </p>
            </div>
            <div className="bg-sky-100 lg:w-1/3 w:auto flex-1 sm:p-10 p-8 my-5 lg:mx-5 mx-0 rounded-3xl">
              <h3 className="sm:text-2xl text-xl">Our Mission</h3>
              <p className="text-justify sm:text-lg text-base pt-0">
                PMHA exists to promote mental health and well-being among the
                general population, address mental health issues, eradicate
                stigma, and inspire individuals to become mental health
                advocates.
              </p>
            </div>
            <div className="bg-sky-100 lg:w-1/3 w:auto flex-1 sm:p-10 p-8 my-5 lg:mx-5 mx-0 rounded-3xl">
              <h3 className="sm:text-2xl text-xl">Our Advocacy</h3>
              <p className="text-justify sm:text-lg text-base pt-0">
                We will continue to enhance individual and collective well-being
                for a mentally healthy Philippines!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* HOW WE DO IT */}
      <section className="bg-[#f8f8f8] pt-24 pb-48 mt-24">
        <div className="max-w-screen-xl mx-auto sm:px-10 px-8">
          <div className="grid">
            <h2 className="md:text-4xl text-3xl leading-tight text-blue border-b border-b-gray-300 pb-5 mb-6">
              How we do it
            </h2>
            <p className="text-justify sm:text-lg text-base">
              Through its compassionate, committed, and competent mental health
              professionals, PMHA provides capacity-building activities such as
            </p>
          </div>
          <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-10 mt-14">
            <div className="col-span-1">
              <div className="svg-wrap bg-white drop-shadow-xl rounded-full max-w-[130px] mx-auto p-3">
                <ReactSVG src="assets/img/icons/orientations.svg" />
              </div>
              <h3 className="font-semibold md:text-xl text-lg text-center pt-8">
                Orientations
              </h3>
            </div>
            <div className="col-span-1">
              <div className="svg-wrap bg-white drop-shadow-xl rounded-full max-w-[130px] mx-auto p-3">
                <ReactSVG src="assets/img/icons/mental-health.svg" />
              </div>
              <h3 className="font-semibold md:text-xl text-lg text-center pt-8">
                Mental Health <br /> Learning Sessions
              </h3>
            </div>
            <div className="lg:col-span-1 sm:col-span-2 grid-cols-1">
              <div className="svg-wrap bg-white drop-shadow-xl rounded-full max-w-[130px] mx-auto p-3">
                <ReactSVG src="assets/img/icons/lecture-fora.svg" />
              </div>
              <h3 className="font-semibold md:text-xl text-lg text-center pt-8">
                Lecture-fora
              </h3>
            </div>
          </div>
          <div className="grid mt-14">
            <p className="text-justify sm:text-lg text-base">
              We use multimedia platforms for various stakeholders and
              vulnerable groups through partnership with local and international
              organizations. We provide community—based and family focused
              services which includes the following:
            </p>
          </div>

          <div className="grid max-w-4xl mx-auto mt-5">
            <div className="border-b py-8">
              <div className="grid grid-cols-4 gap-5 items-center">
                <div className="col-span-1">
                  <p className="text-lg">01</p>
                </div>
                <div className="col-span-3">
                  <h4 className="lg:text-2xl text-lg">Assessment</h4>
                </div>
              </div>
            </div>
            <div className="border-b py-8">
              <div className="grid grid-cols-4 gap-5 items-center">
                <div className="col-span-1">
                  <p className="text-lg">02</p>
                </div>
                <div className="col-span-3">
                  <h4 className="lg:text-2xl text-lg">Treatment</h4>
                </div>
              </div>
            </div>
            <div className="border-b py-8">
              <div className="grid grid-cols-4 gap-5 items-center">
                <div className="col-span-1">
                  <p className="text-lg">03</p>
                </div>
                <div className="col-span-3">
                  <h4 className="lg:text-2xl text-lg">Rehabilitation</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* QUOTE */}
      <section className="max-w-screen-2xl mx-auto sm:px-10 px-8 -m-28">
        <div className="relative max-w-4xl mx-auto bg-white rounded-3xl shadow-md flex items-center md:p-14 sm:p-10 p-8">
          <div className="bg-blue w-full md:max-w-[60px] sm:max-w-[50px] max-w-[40px] rounded-bl-3xl absolute bottom-0 left-0 py-5 px-3">
            <Image src={QuoteIcon} alt="Quote Icon" />
          </div>
          <h2 className="font-semibold font-CantoraOne lg:text-4xl sm:text-3xl text-2xl !leading-normal sm:pl-8 pl-5 mb-0">
            We cater to every person regardless of gender, race, political
            affiliation, religion and socio-economic status.
          </h2>
        </div>

        <div className="grid py-24">
          <h2 className="md:text-4xl text-3xl leading-tight text-blue border-b border-b-gray-300 pb-5 mb-10">
            Our Core Values
          </h2>
          <div className="grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-8">
            <div className="col-span-1 flex justify-items-stretch">
              <div className="bg-gray-50 rounded-xl py-8 px-6">
                <div className="svg-wrap bg-white drop-shadow-xl rounded-full max-w-[100px] mx-auto mb-5 p-4">
                  <ReactSVG src="assets/img/icons/human-dignity-icon.svg" />
                </div>
                <h3 className="text-center text-lg font-semibold mb-3">
                  Human Dignity
                </h3>
                <p className="text-justify sm:text-lg text-base">
                  Respect for the personal worth and dignity of every person and
                  all communities that we serve regardless of gender, race,
                  political affiliation, religion and socio-economic status.
                </p>
              </div>
            </div>
            <div className="col-span-1 flex justify-items-stretch">
              <div className="bg-gray-50 rounded-xl py-8 px-6">
                <div className="svg-wrap bg-white drop-shadow-xl rounded-full max-w-[100px] mx-auto mb-5 p-4">
                  <ReactSVG src="assets/img/icons/compassion-icon.svg" />
                </div>
                <h3 className="text-center text-lg font-semibold mb-3">
                  Compassion
                </h3>
                <p className="text-justify sm:text-lg text-base">
                  Caring response to the mental, emotional, behavioral,
                  spiritual and physical needs of every person and community
                  that we serve.
                </p>
              </div>
            </div>
            <div className="col-span-1 flex justify-items-stretch">
              <div className="bg-gray-50 rounded-xl py-8 px-6">
                <div className="svg-wrap bg-white drop-shadow-xl rounded-full max-w-[100px] mx-auto mb-5 p-4">
                  <ReactSVG src="assets/img/icons/integrity-icon.svg" />
                </div>
                <h3 className="text-center text-lg font-semibold mb-3">
                  Integrity
                </h3>
                <p className="text-justify sm:text-lg text-base">
                  Honesty, moral uprightness, consistency of actions, adherence
                  to truthfulness, and upholding the highest standards of
                  ethical practice.
                </p>
              </div>
            </div>
            <div className="col-span-1 flex justify-items-stretch">
              <div className="bg-gray-50 rounded-xl py-8 px-6">
                <div className="svg-wrap bg-white drop-shadow-xl rounded-full max-w-[100px] mx-auto mb-5 p-4">
                  <ReactSVG src="assets/img/icons/stewardship-icon.svg" />
                </div>
                <h3 className="text-center text-lg font-semibold mb-3">
                  Stewardship
                </h3>
                <p className="text-justify sm:text-lg text-base">
                  Responsible stewardship of human, financial, technological,
                  intellectual property and physical resources of the
                  Association.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Blurb */}
      <>
        <section className="mt-32 relative">
          <div className="w-full relative group">
            <div className="grid grid-cols-3 lg:gap-x-6 md:gap-x-4 gap-x-2">
              <div className="col-span-1">
                <div className="items-center bg-[url('/assets/img/img-3.jpg')] bg-cover bg-no-repeat bg-center relative lg:min-h-[700px] md:min-h-[500px] sm:min-h-[400px] min-h-[300px]">
                  <div className="grid place-items-center h-full"></div>
                </div>
              </div>
              <div className="col-span-1">
                <div className="items-center bg-[url('/assets/img/stock-photo-7674917.jpeg')] bg-cover bg-no-repeat bg-center relative lg:min-h-[700px] md:min-h-[500px] sm:min-h-[400px] min-h-[300px]">
                  <div className="grid place-items-center h-full"></div>
                </div>
              </div>
              <div className="col-span-1">
                <div className="items-center bg-[url('/assets/img/img-2.jpg')] bg-cover bg-no-repeat bg-center relative lg:min-h-[700px] md:min-h-[500px] sm:min-h-[400px] min-h-[300px]">
                  <div className="grid place-items-center h-full"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>

      {/* BOOKING CALL TO ACTION */}
      <BookingSec />

      {/* FOOTER */}
      <Footer />
    </>
  );
};

export default About;
